















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ListEmpty from './icons/ListEmpty.vue'
import NotFound from './icons/NotFound.vue'

const icons: Record<string, typeof Vue> = {
  'list-empty': ListEmpty,
  'not-found': NotFound,
}

@Component
export default class EmptyData extends Vue {
  @Prop() readonly icon!: string

  @Prop({ required: false, type:String, default: 'list_empty' }) description!:string

  get iconName(): typeof Vue {
    return icons[this.icon] || icons['list-empty']
  }

  get emptyDataDescription():string {
    if (this.$slots.description) {
      return ''
    } else {
      return this.$t(`${ this.description }`).toString()
    }
  }
}
